import { Action, creator } from 'src/config/rootAction';

import { ProgramEnum } from '../../models/programs';
import {
    ChangeFeedbackFieldData,
    FetchedProgramFeedback,
    FetchedWeekFeedback,
    FetchWeekFeedbackData,
    SubmitFeedbackData,
} from '../models/feedback';

export const FETCH_WEEK_FEEDBACK_REQUESTED = 'FETCH_WEEK_FEEDBACK_REQUESTED';
export type FetchWeekFeedbackRequestAction = Action<
    typeof FETCH_WEEK_FEEDBACK_REQUESTED,
    FetchWeekFeedbackData
>;
export const fetchWeekFeedback = creator<FetchWeekFeedbackRequestAction>(
    FETCH_WEEK_FEEDBACK_REQUESTED,
);

export const FETCH_WEEK_FEEDBACK_SUCCEEDED = 'FETCH_WEEK_FEEDBACK_SUCCEEDED';
export type FetchWeekFeedbackSuccessAction = Action<
    typeof FETCH_WEEK_FEEDBACK_SUCCEEDED,
    FetchedWeekFeedback
>;
export const fetchWeekFeedbackSuccess = creator<FetchWeekFeedbackSuccessAction>(
    FETCH_WEEK_FEEDBACK_SUCCEEDED,
);

export const FETCH_WEEK_FEEDBACK_FAILED = 'FETCH_WEEK_FEEDBACK_FAILED';
export type FetchWeekFeedbackFailAction = Action<typeof FETCH_WEEK_FEEDBACK_FAILED>;
export const fetchWeekFeedbackFail = creator<FetchWeekFeedbackFailAction>(
    FETCH_WEEK_FEEDBACK_FAILED,
);

export const FETCH_PROGRAM_FEEDBACK_REQUESTED = 'FETCH_PROGRAM_FEEDBACK_REQUESTED';
export type FetchProgramFeedbackRequestAction = Action<
    typeof FETCH_PROGRAM_FEEDBACK_REQUESTED,
    ProgramEnum
>;
export const fetchProgramFeedback = creator<FetchProgramFeedbackRequestAction>(
    FETCH_PROGRAM_FEEDBACK_REQUESTED,
);

export const FETCH_PROGRAM_FEEDBACK_SUCCEEDED = 'FETCH_PROGRAM_FEEDBACK_SUCCEEDED';
export type FetchProgramFeedbackSuccessAction = Action<
    typeof FETCH_PROGRAM_FEEDBACK_SUCCEEDED,
    FetchedProgramFeedback
>;
export const fetchProgramFeedbackSuccess = creator<FetchProgramFeedbackSuccessAction>(
    FETCH_PROGRAM_FEEDBACK_SUCCEEDED,
);

export const FETCH_PROGRAM_FEEDBACK_FAILED = 'FETCH_PROGRAM_FEEDBACK_FAILED';
export type FetchProgramFeedbackFailAction = Action<typeof FETCH_PROGRAM_FEEDBACK_FAILED>;
export const fetchProgramFeedbackFail = creator<FetchProgramFeedbackFailAction>(
    FETCH_PROGRAM_FEEDBACK_FAILED,
);

export const CHANGE_FEEDBACK_FIELD = 'CHANGE_FEEDBACK_FIELD';
export type ChangeFeedbackFieldAction = Action<
    typeof CHANGE_FEEDBACK_FIELD,
    ChangeFeedbackFieldData
>;
export const changeFeedbackField = creator<ChangeFeedbackFieldAction>(CHANGE_FEEDBACK_FIELD);

export const SUBMIT_FEEDBACK_REQUESTED = 'SUBMIT_FEEDBACK_REQUESTED';
export type SubmitFeedbackRequestAction = Action<
    typeof SUBMIT_FEEDBACK_REQUESTED,
    SubmitFeedbackData
>;
export const submitFeedback = creator<SubmitFeedbackRequestAction>(SUBMIT_FEEDBACK_REQUESTED);

export const SUBMIT_FEEDBACK_SUCCEEDED = 'SUBMIT_FEEDBACK_SUCCEEDED';
export type SubmitFeedbackSuccessAction = Action<typeof SUBMIT_FEEDBACK_SUCCEEDED>;
export const submitFeedbackSuccess = creator<SubmitFeedbackSuccessAction>(
    SUBMIT_FEEDBACK_SUCCEEDED,
);

export const SUBMIT_FEEDBACK_FAILED = 'SUBMIT_FEEDBACK_FAILED';
export type SubmitFeedbackFailAction = Action<typeof SUBMIT_FEEDBACK_FAILED>;
export const submitFeedbackFail = creator<SubmitFeedbackFailAction>(SUBMIT_FEEDBACK_FAILED);

export type FeedbackAction =
    | FetchWeekFeedbackRequestAction
    | FetchWeekFeedbackSuccessAction
    | FetchWeekFeedbackFailAction
    | FetchProgramFeedbackRequestAction
    | FetchProgramFeedbackSuccessAction
    | FetchProgramFeedbackFailAction
    | ChangeFeedbackFieldAction
    | SubmitFeedbackRequestAction
    | SubmitFeedbackSuccessAction
    | SubmitFeedbackFailAction;
